module.exports = __webpack_public_path__ + "static/img/7.65a1c8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/99/zh/7.png
// module id = 7lc6
// module chunks = 0